var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('combobox',{attrs:{"label":_vm.label,"disabled":_vm.disabled,"options":_vm.modelOptions,"value":_vm.currentModelId},on:{"input":_vm.emitValue,"enter":_vm.emitEnter}})}
var staticRenderFns = []

export { render, staticRenderFns }